import { useErrorBoundary } from '../providers/ErrorBoundaryProvider'

export function ErrorBoundary<T>({
  children,
  ...props
}: React.PropsWithChildren<T>) {
  const ErrorBoundaryComponent = useErrorBoundary()

  return <ErrorBoundaryComponent {...props}>{children}</ErrorBoundaryComponent>
}
